import { cn } from '@/lib/utils'
import ResponsiveImage from '@/v2/components/helpers/responsive-image'
import { TabsType } from '@/v2/types'
import { useRouter, useSearchParams } from 'next/navigation'

interface TabsToggleProps {
  tabs: TabsType[]
  activeTabId: string
}

function RadioButton({ isActive, className }: { isActive: boolean; className?: string }) {
  return (
    <span
      className={cn(
        'block p-[3px] rounded-full border-[3px]',
        isActive ? 'bg-[#fff]  border-secondary' : 'bg-transparent border-[#A5A5A5]',
        className
      )}
    >
      <span
        className={cn(
          'xl:h-[26px] xl:w-[26px] w-[17px] h-[17px] rounded-full block',

          isActive ? 'bg-secondary' : 'bg-transparent '
        )}
      />
    </span>
  )
}

const TabsToggle: React.FC<TabsToggleProps> = props => {
  const { tabs, activeTabId } = props

  const searchParams = useSearchParams()
  const router = useRouter()

  const handleTabClick = (id: number) => {
    const newSearchParams = new URLSearchParams(Array.from(searchParams.entries()))
    newSearchParams.set('tab', id.toString())
    router.replace(`?${newSearchParams.toString()}`, { scroll: false })
  }

  return (
    <div className='flex items-center gap-[15px] xl:gap-[75px]'>
      {tabs?.map(tab => {
        const isActive = tab.id === parseInt(activeTabId)

        return (
          <div
            key={tab.id}
            className={cn(
              'my-[10px] w-full border-[3px] transition-all p-[5px] md-mn:py-0 cursor-pointer h-[120px] md-mn:h-[60px] xl:!h-[127px] [&_h2]:self-start md-mn:[&_h2]:self-center rounded-lg  flex items-center justify-around md-mn:justify-between md-mn:flex-row flex-col-reverse px-[20px] [&>h2]:font-[700] xl:[&>h2]:text-[36px] [&>h2]:text-left [&>h2]:text-[16px] [&>h2]:leading-[20px] xl:[&>h2]:leading-[56px] [&>h2]:flex  [&>h2]:items-center  [&>h2]:gap-[12px]',
              isActive ? 'border-secondary [&>h2]:text-secondary' : '[&>h2]:text-[#A5A5A5] border-[#A5A5A5]'
            )}
            onClick={() => handleTabClick(tab.id ?? 0)}
          >
            <h2>
              <RadioButton isActive={isActive} className='md:block hidden' />
              {tab.title}
            </h2>

            <div className='flex items-center md-mn:self-center self-start'>
              <RadioButton isActive={isActive} className='md:hidden block' />
              <ResponsiveImage
                src={tab.image.src}
                alt={tab.image.alt}
                className='w-[76px] h-[48px] xl:w-[160px] xl:h-[100px] md-mn:ml-auto'
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default TabsToggle
